module.exports = __webpack_public_path__ + "img/电梯动画11.71a41e9b.png";